import { errorTypes, networkErrorToMessage } from 'commons/error'
import { useDispatch } from 'react-redux'
import MessageAlert from 'app/components/MessageAlert'
import React, { useState, useCallback, useRef, useEffect, useMemo } from 'react'
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Icon,
  Typography,
  Divider,
  MenuItem,
  Button,
  Menu,
  Tooltip,
  IconButton,
  CircularProgress,
  useMediaQuery,
  Chip,
  FormControlLabel,
  Grid,
  Box,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { TextFieldFormsy } from '@fuse'
import { useIntl, FormattedMessage } from 'react-intl'
import * as R from 'ramda'
import { validateEmtpyValueFormsy } from 'commons/validateEmtpyValueFormsy'
import clsx from 'clsx'
import effects from 'app/effects/effects'
import {
  humanizedTimeIndicator,
  getDateTimeDiff,
} from 'libs/humanizedTimeIndicator/humanizedTimeIndicator'
import PDFMediaSection from './PDFMediaSection'
import { useDefaultLanguage } from 'commons/useDefaultLanguage'
import { kilobytesToMegaBtyes } from 'libs/file'
import ErrorBoundary from 'app/components/ErrorBoundary'
import Formsy from 'formsy-react'
import FrameShowYoutube from 'app/components/media/FrameYoutubeUrl'
import PropTypes from 'prop-types'
import { ButtonWithLoading } from './FormsyHelperComponent'
import { useUserProfile } from 'commons/useUserProfile'
import RichTextDisplay from 'app/components/richTextEditor/RichTextDisplay'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import Assets from 'app/configs/assetConfigs'
import { priorityFromApi } from 'app/main/notification/submit/NotiApiMapper'
import CancelReminderButton from '../main/messages/notificationTimeline/cancelReminder/CancelReminderButton'
import { viewLogo, viewName } from 'app/main/notification/PreviewMapper'
import { usePlace } from 'commons/usePlace'
import {
  timeFormat,
  eventDateFormat,
  getDateAndTimeAndTimezone as parseDateAndTimeAndTimezone,
  getLocalizedDate,
} from 'commons/date'
import { CancelScheduleNotification } from 'app/main/messages/notificationTimeline/cancelScheduleNotification/CancelScheduleNotification'
import UnsendNotificationButton from 'app/main/messages/notificationTimeline/unsendNotification/UnsendNotification'
import CancelScheduleNotificationStatus from 'app/main/messages/notificationTimeline/cancelScheduleNotification/CancelScheduleNotificationStatus'
import { anyExist, isExist } from 'libs/ramdaExt'
import {
  formatHomelessSubgroup,
  EVERYONE_GROUP_NAME,
  HOMELESS_GROUP_NAME,
  everyoneGroupName,
  homelessGroupName,
} from 'commons/groupLogic'
import { useNotificationInfo } from 'app/main/messages/notificationTimeline/useNotificationInfo'
import ErrorView from './ErrorView'
import IconLinkButton from './buttons/IconLinkButton'
import CommentList from 'app/main/messages/notificationTimeline/commentReplay/CommentList'
import ExtraSection from 'app/main/messages/notificationTimeline/commentReplay/ExtraSection'
import EventNotificationActions from 'app/main/messages/notificationTimeline/eventNotificationActions/EventNotificationActions'
import NotificationCardEventActions from 'app/components/NotificationCardEventActions'
import { useTheme } from '@material-ui/core/styles'
import { PaidPlanAccess } from 'app/auth/paidPlanAccess'
import PaidPlanAccessBlock from 'app/auth/PaidPlanAccessBlock'
import GreyBox from 'app/components/GreyBox'
import { useNotificationEventStatus } from 'app/main/notification/useNotificationEventStatus'

import NotificationCardAudio from './NotificationCardAudio'

import AttachedVoucherSection from 'app/main/messages/notificationTimeline/voucherNotification/AttachedVoucherSection'
import { changeTimezone } from 'libs/dateUtils'
import TimelineImageSection from 'app/components/TimelineImageSection'
import { mediaToImages } from 'app/components/TimelineLightbox'
import ShareButton from 'app/components/notificationCard/ShareButton'
import MetricAnalyticWithTabs from './metricAnalyticWithTabs'
import PersonAvatar from './PersonAvatar'
import DefaultSwitch from 'app/components/switch/DefaultSwitch'
import ViaChannelCount from 'app/components/ViaChannelCount'
import 'styles/initial-notification.css'
import NotificationMetricWithoutChannel from 'app/main/messages/notificationTimeline/notificationMetricWithoutChannel'
import createAvatarFromCharacters from 'libs/avatarCharactersHelpers'
import Axios from 'axios'
import Topic from 'app/components/Topic'
import Status from 'app/components/StatusText'
import ViewInButton from 'app/components/notificationCard/ViewInButton'
import NotificationBadge from 'app/components/NotificationBadge'
import ReminderBadge from './ReminderBadge'
import useMessageExpiration from 'commons/useMessageExpiration'
import DisplayHistoryToggle from './DisplayHistoryToggle'
import CancelExpirationButton from 'app/main/messages/notificationTimeline/CancelExpiration'
import { useFlag } from '@unleash/proxy-client-react'
import {
  CHANNEL_CALL,
  CHANNEL_APP,
  CHANNEL_EMAIL,
  CHANNEL_SMS,
  INSTAGRAM_VALUE,
  FACEBOOK_VALUE,
  TWITTER_VALUE,
  LINKEDIN_VALUE,
} from 'app/constants/channel'
import {
  NOTI_PRIORITY_HIGH,
  NOTI_PRIORITY_LOW,
  NOTI_PRIORITY_URGENT,
  NOTI_PRIORITY_EMERGENCY,
} from 'app/constants/priority'
import { TYPE_VOUCHER } from 'app/constants/messageType'

export const NORMAL_NOTIFICATION = 'TYPE_NORMAL'
export const INITIAL_NOTIFICATION = 'TYPE_INITIAL'
export const SCHEDULED_NOTIFICATION = 'TYPE_SCHEDULED'
export const VOUCHER_NOTIFICATION = 'TYPE_VOUCHER'
export const API_NORMAL_NOTIFICATION = 1
export const API_SCHEDULED_NOTIFICATION = 2
export const COMMENT_CREATOR_TYPE_CREATOR = 1
export const COMMENT_CREATOR_TYPE_COMMENTER = 2
export const API_GENERAL_NOTIFICATION = 1
export const API_EVENT_NOTIFICATION = 2
export const API_VOUCHER_NOTIFICATION = 3

const INITIAL_SCOPE = 2
const AUDIO_PROCESS = 'process'

const recipientToTooltipDisplay =
  (formatMessage) => (subGroups, subscribers) => {
    let listResult = []
    R.compose(
      (txt) => (!R.isEmpty(txt) ? listResult.push(txt) : listResult),
      R.join(', '),
      R.map(([name, subgroups]) =>
        R.cond([
          [
            R.equals(EVERYONE_GROUP_NAME),
            R.always(everyoneGroupName(formatMessage)),
          ],
          [
            R.equals(HOMELESS_GROUP_NAME),
            R.always(homelessGroupName(formatMessage)),
          ],
          [
            R.T,
            R.always(
              R.join('', [
                name,
                ' (',
                R.join(', ', R.map(R.prop('name'), subgroups)),
                ')',
              ]),
            ),
          ],
        ])(name),
      ),
      R.toPairs,
      R.groupBy(R.path(['group', 'name'])),
    )(subGroups)

    R.compose(
      (txt) => (!R.isEmpty(txt) ? listResult.push(txt) : listResult),
      R.join(', '),
      R.map(
        (sub) =>
          `${R.propOr('', 'firstName', sub)} ${R.propOr('', 'lastName', sub)}`,
      ),
    )(subscribers)

    return R.join(', ', listResult)
  }

const useStyles = makeStyles((theme) => ({
  textPreview: {
    position: 'absolute',
    width: '100%',
    bottom: 0,
    height: '35px',
    background:
      'repeating-linear-gradient(rgba(255, 255, 255, 0), #ffffff 30px)',
    [theme.breakpoints.down('xs')]: {
      height: 'calc(100% - 400px)',
    },
  },
  previewButton: {
    width: '100%',
    paddingBottom: '0.8rem',
    marginTop: '0.8rem',
  },
  audioPlayerWrapper: {
    marginTop: 25,
    marginBottom: 15,
  },
  ttsProcessingTxt: {
    color: 'red',
    marginRight: '1.6rem',
    display: 'inline-block',
  },
  languageSelect: {
    '& .MuiInputBase-inputSelect': {
      paddingRight: '0px',
      paddingLeft: '4px',
    },
    '& .MuiTypography-root': {
      marginBottom: '.1rem',
    },
  },
  selectIcon: {
    display: 'none',
  },
  darkGreyText: {
    color: theme.palette.darkGrey.main,
  },
  lightGreyText: {
    color: theme.palette.text.lightGrey,
    fontSize: '1.2rem',
  },
  keyIconStyle: {
    color: theme.palette.darkGrey.main,
    fontSize: '1.6rem',
    marginBottom: '0.2rem',
  },
  avatarIcon: {
    width: '32px',
    height: '32px',
    fontSize: '14px',
  },
  cardPadding: {
    '& .MuiCardContent-root': {
      padding: '8px 16px',
    },
  },
  cardHeaderPadding: {
    '& .MuiCardHeader-avatar': {
      marginRight: '16px',
      [theme.breakpoints.down('xs')]: {
        marginRight: '8px',
      },
    },
    '& .MuiCardHeader-content': {
      position: 'relative',
    },
  },
  eventDate: {
    color: theme.palette.event.eventDate,
  },
  eventTimezone: {
    color: theme.palette.event.eventTimezone,
    marginLeft: '4px',
  },
  eventLocation: {
    color: theme.palette.event.eventLocation,
    '& img': {
      height: '10px',
    },
  },
  chipStatusStyle: {
    height: '21px',
    marginLeft: '5px',
    margin: '5px',
    color: theme.palette.primary.text,
  },
  image: {
    maxHeight: 700,
    maxWidth: 726,
  },
  imageText: {
    position: 'absolute',
    bottom: '8px',
    right: '16px',
  },
  imageMask: {
    position: 'absolute',
    backgroundImage:
      'linear-gradient(to top, #000000 1%, rgba(84, 84, 84, 0.27) 60%)',
    opacity: '0.27',
    width: '100%',
    height: '100%',
  },
  voucherImage: {
    width: '334px',
  },
  directionRtl: {
    direction: 'rtl',
  },
  textColorBlur: {
    fontSize: '12px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    color: '#247bcd',
  },
  dotColor: {
    color: '#00314b',
  },
  shareResponsive: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '@media(max-width:391px)': {
      '&:first-child': {
        width: '19%',
      },
      '@media(max-width:380px)': {
        flexWrap: 'wrap',
        '& >div:first-child': {
          marginRight: '50%',
        },
        '& >div:nth-child(2)': {
          marginTop: '-12px',
        },
      },
    },
  },
  messageSentBy: {
    '@media(max-width:395px)': {
      flexDirection: 'column',
    },
  },
  messageSentByCont: {
    flexWrap: 'wrap',
    '@media(max-width:425px)': {
      flexDirection: 'column',
    },
  },
}))

export const mapTypeFromApiToNotificationType = R.cond([
  [
    anyExist(['scheduleDate', 'sendDate', 'scheduleCancelDate']),
    R.always(SCHEDULED_NOTIFICATION),
  ],
  [R.T, R.always(NORMAL_NOTIFICATION)],
])

const SmallLoading = () => (
  <div className="h-36 w-36 flex items-center justify-center">
    <CircularProgress color="secondary" size={14} />
  </div>
)

const NotificationCard = (props) => {
  const {
    onProfileInfoClick,
    onSubscriptionClick,
    onAnalyticClick,
    notificationType = NORMAL_NOTIFICATION,
    onEditInitialNotification,
    setEventActionDialog,
    openEventSubscribersDialog,
    currentMusicPlaying,
    isOnline,
    availableLangs,
    checkAudio,
    isHideTtsHistory,
    isEnabledTts,
    setLightboxState,
    toggleVoucher,
    onUpdateDisplayHistory,
    ...extraProps
  } = props
  const mes_718_show_more_description = useFlag('mes_718_show_more_description')

  const classes = useStyles()
  const dispatch = useDispatch()
  const defaultLanguage = useDefaultLanguage()
  const { formatMessage } = useIntl()
  const scrollRef = useRef(null)

  const TABTITLES = [
    {
      id: 1,
      title: formatMessage({ id: 'metrics.delivery.rate' }),
      value: 'deliver',
    },
    {
      id: 2,
      title: formatMessage({ id: 'metrics.view.rate' }),
      value: 'read',
    },
    {
      id: 3,
      title: formatMessage({ id: 'metrics.user.reaction' }),
      value: 'reaction',
    },
    {
      id: 4,
      title: formatMessage({ id: 'metrics.listen' }),
      value: 'tts',
    },
    {
      id: 5,
      title: formatMessage({ id: 'metrics.media.opened' }),
      value: 'media',
    },
  ]

  const DEFAULT_METRIC = 'deliver'
  const userData = useUserProfile()
  const place = usePlace()
  const getFullName = ({ firstName, lastName }) => {
    let fullName = [firstName, lastName]
      .filter((v) => {
        return !R.isNil(v)
      })
      .join(' ')
    return R.isEmpty(fullName)
      ? formatMessage({
          id: 'notificationTimeline.card.noPosterName',
        })
      : fullName
  }

  const isInitialNotification = R.equals(notificationType, INITIAL_NOTIFICATION)

  const notificationPriority = (notification) => {
    switch (R.prop('priority', notification)) {
      case NOTI_PRIORITY_HIGH.id:
        return (
          <NotificationBadge
            localizedId={formatMessage({
              id: 'createNotification.dialog.notiPriority.high',
            })}
            imageAsset={Assets.notiPriorityInNotiCard.important}
          />
        )

      case NOTI_PRIORITY_LOW.id:
        return (
          <NotificationBadge
            localizedId={formatMessage({
              id: 'createNotification.dialog.notiPriority.low',
            })}
            imageAsset={Assets.notiPriorityInNotiCard.informational}
          />
        )

      case NOTI_PRIORITY_URGENT.id:
        return (
          <NotificationBadge
            localizedId={formatMessage({
              id: 'createNotification.dialog.notiPriority.urgent',
            })}
            imageAsset={Assets.notiPriorityInNotiCard.urgent}
          />
        )

      case NOTI_PRIORITY_EMERGENCY.id:
        return (
          <NotificationBadge
            localizedId={formatMessage({
              id: 'createNotification.dialog.notiPriority.emergency',
            })}
            imageAsset={Assets.notiPriorityInNotiCard.emergency}
          />
        )

      default:
        break
    }
  }

  const isSentScheduledNotification = (notification) => {
    const { diffTimeInMilliseconds } = getDateTimeDiff(
      moment(),
      moment(R.prop('sendDate', notification)),
    )
    return diffTimeInMilliseconds > 0
  }

  const parser = (model, translation) => {
    let notificationMedias = R.prop('medias', model)
    let media = R.isNil(notificationMedias)
      ? null
      : notificationMedias.length === 0
        ? null
        : {
            url: notificationMedias[0].url,
            type: notificationMedias[0].type,
            fileSizeInMegabytes: kilobytesToMegaBtyes(
              notificationMedias[0].fileSize,
            ),
            fileName: notificationMedias[0].fileName,
          }

    const checkCommentCreator = () => {
      if (R.isEmpty(model.types)) {
        return COMMENT_CREATOR_TYPE_CREATOR
      } else {
        return COMMENT_CREATOR_TYPE_COMMENTER
      }
    }
    return {
      ...model,
      id: R.prop('id', model),
      posterName: isInitialNotification
        ? R.path(['place', 'name'], model)
        : getFullName({
            firstName: R.path(['user', 'firstName'], model),
            lastName: R.path(['user', 'lastName'], model),
          }),
      creatorType: checkCommentCreator(),
      posterId: R.path(['user', 'id'], model),
      place: {
        name: viewName(place),
        image: viewLogo(place),
      },
      posterAvatar:
        R.path(['user', 'id'], model) === userData.id
          ? userData.photoURL
          : R.path(['user', 'avatar'], model),
      type: R.prop('type', model),
      isTtsEnabledTarget: R.prop('isTtsEnabled', translation),
      title: R.prop('title', translation),
      body: R.prop('body', translation),
      descriptionPreview: R.prop('descriptionPreview', translation),
      audioUrl: audioUrlCheck === AUDIO_PROCESS ? undefined : audioUrlCheck,
      isTtsEnabled: R.prop('isTtsEnabled', translation),
      media: media,
      images: R.prop('medias', model),
      priority: priorityFromApi(R.prop('level', model)),
      analytics: R.prop('analytics', model),
      startTime: R.prop('startTime', model),
      endTime: R.prop('endTime', model),
      timezone: R.prop('timezone', model),
      address: R.prop('address', model),
      eventStatus: R.prop('eventStatus', model),
      eventActionsCount: R.prop('eventActionsCount', model),
      humanizedTimeIndicator: isInitialNotification
        ? formatMessage({
            id: 'notificationPreview.placeholderTime',
          })
        : humanizedTimeIndicator({
            timestamp: R.prop('createdAt', model),
            languageCode: R.prop('code', defaultLanguage),
            formatMessage: formatMessage,
            timezone: R.prop('timezone', model),
          }),
      language: R.prop('language', translation),
      scheduleDate: R.prop('scheduleDate', model),
      scheduleTimezone: R.prop('scheduleTimezone', model),
      reminderDate: R.prop('reminderDate', model),
      reminderTimezone: R.prop('reminderTimezone', model),
      cancelReason: R.prop('cancelReason', translation),
      canceledDate: R.prop('canceledDate', model),
      ...R.pickAll([
        'commentsCount',
        'scheduleCancelDate',
        'scheduleCanceledBy',
        'subGroups',
        'subscribers',
        'updatedAt',
        'createdAt',
        'unsentBy',
        'unsentDate',
        'eventStatus',
        'sendDate',
        'displayHistory',
      ])(model),
      voucher: R.prop('voucher', model),
      voucherTitle: R.prop('voucherTitle', translation),
      voucherDescription: R.prop('voucherDescription', translation),
      limitAmount: R.prop('limitedAmount', model),
      voucherUseCount: R.propOr(0, 'voucherUseCount', model),
    }
  }

  const [selectedLanguageId, setSelectedLanguageId] = useState(
    defaultLanguage.id,
  )
  const [selectedLanguage, setSelectedLanguage] = useState(
    props.notification.translations[0],
  )

  const [audioUrlCheck, setAudioUrlCheck] = useState(
    R.prop('audioUrl', selectedLanguage) || undefined,
  )

  const updateNotificationtranslation = () => {
    setSelectedLanguage(props.notification.translations[0])
  }

  useEffect(updateNotificationtranslation, [props.notification.updatedAt])

  const notification = parser(props.notification, selectedLanguage)

  const withoutAnyChannel =
    !R.prop('channels', notification).includes(CHANNEL_APP) &&
    !R.prop('channels', notification).includes(CHANNEL_EMAIL) &&
    !R.prop('channels', notification).includes(CHANNEL_SMS) &&
    !R.prop('channels', notification).includes(CHANNEL_CALL)

  const [isPageLoad, setIsPageLoad] = useState(false)
  const [{ eventStatusLabelId, classColorStatus, isShowStatus }] =
    useNotificationEventStatus(notification.eventStatus)

  const {
    isLoading: isInfoLoading,
    isShowComments,
    isShowMetrics,
    comments,
    commentsCount,
    metrics,
    onToggleShowComments,
    onToggleShowMetrics,
    refetchNotification,
    error: infoError,
  } = useNotificationInfo(R.prop('id', notification))
  const creatorName = notification.posterName
  const [isFormValid, setIsFormValid] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  //MARK:- The statement below will be used soon.
  // eslint-disable-next-line no-unused-vars
  const [showingComment, setShowingComment] = useState()
  const [commentItemSummary, setCommentItemSummary] = useState()

  const entityId = R.prop('id', notification)
  const commentTextFieldRef = useRef(null)
  const SHOWING_COMMENT_SIZE = 10

  const commentRef = useRef()
  const notificationId = R.prop('id', notification)
  const placeNotification = R.prop('notification', props)
  const placeTopics = R.prop('placeTopics', placeNotification)

  const [preparingMsg, setPreparingMsg] = useState('')
  const [translationFaileId, setTranslationFaileId] = useState(null)
  const [isInterval, setIsInterval] = useState(true)

  const isTranslation = R.prop('isTranslationEnded', notification)

  const messageExpiration = useMessageExpiration(notification)

  const checkCommentEntityType = useCallback(() => {
    const NOTIFICATION_COMMENT = 2
    if (notificationId) {
      return NOTIFICATION_COMMENT
    }
  }, [notificationId])

  const commentCount = useCallback(() => {
    return R.when(R.isNil, () => R.prop('commentsCount', notification))(
      commentsCount,
    )
  }, [commentsCount, notification])

  useEffect(() => {
    let commentSummary = commentCount()
    setCommentItemSummary(commentSummary)

    commentSummary >= SHOWING_COMMENT_SIZE
      ? setShowingComment(SHOWING_COMMENT_SIZE)
      : setShowingComment(commentSummary)
  }, [commentCount])

  useEffect(() => {
    if (!isTranslation) {
      setTranslationFaileId(notificationId)
      setPreparingMsg(
        formatMessage({
          id: 'notificationTimeline.card.subgroupList.preparing.prefix',
        }),
      )
    } else {
      let interval = setTimeout(() => setIsInterval(false), 3000)
      return () => {
        clearTimeout(interval)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [R.prop('isTranslationEnded', notification)])

  function scrollToCommentBox() {
    commentTextFieldRef.current.focus()
  }

  function commentCountText() {
    let commentSummary = commentCount()
    if (commentSummary > 0) {
      return formatMessage(
        { id: 'timeline.detail.message.count.comments' },
        { commentCount: commentSummary },
      )
    } else {
      return formatMessage({
        id: 'timeline.detail.message.comment',
      })
    }
  }

  const handleCommentCountFromReply = useCallback(() => {
    setShowingComment(commentItemSummary + 1)
    setCommentItemSummary(commentItemSummary + 1)
  }, [commentItemSummary])

  function handleEnterToSubmit(e) {
    const ENTER_KEY = 'Enter'
    if (e.key === ENTER_KEY && e.shiftKey) {
      return
    } else if (e.key === ENTER_KEY) {
      e.preventDefault()
      validateEmptyEditingComment()
    }
  }

  function validateEmptyEditingComment() {
    if (
      R.compose(
        R.not,
        R.anyPass([R.isNil, R.isEmpty]),
      )(commentRef.current.getModel().comment)
    ) {
      createComment(commentItemSummary)
    } else {
      return
    }
  }

  const creatorId = R.prop('id', userData)
  const creatorType = R.prop('creatorType', notification)

  const createComment = useCallback(
    (commentItemSummary) => {
      setIsSubmitting(true)
      effects.apis
        .createComment({
          creatorId,
          creatorType,
          entityId,
          entityType: checkCommentEntityType(),
          text: commentRef.current.getModel().comment,
        })
        .then(() => {
          setIsSubmitting(false)
          setIsFormValid(false)
          commentRef.current.reset()
          setShowingComment(commentItemSummary + 1)
          setCommentItemSummary(commentItemSummary + 1)
          refetchNotification()
        })
        .catch((error) => {
          setIsSubmitting(false)
          return dispatch(
            MessageAlert.showNetworkError(formatMessage)(
              error,
              errorTypes.default,
            ),
          )
        })
    },
    [
      checkCommentEntityType,
      dispatch,
      entityId,
      formatMessage,
      creatorId,
      creatorType,
      refetchNotification,
    ],
  )

  const deleteComment = useCallback(
    (id, entityId) => {
      effects.apis
        .deleteComment(id)
        .then(() => {
          setShowingComment(commentItemSummary - 1)
          setCommentItemSummary(commentItemSummary - 1)
        })
        .then(() => {
          dispatch(
            MessageAlert.showSuccess({
              message: formatMessage({
                id: 'notificationTimeline.card.comment.delete.success',
              }),
            }),
          )
          refetchNotification()
        })
        .catch((error) => {
          return dispatch(
            MessageAlert.showNetworkError(formatMessage)(
              error,
              errorTypes.default,
            ),
          )
        })
    },
    [commentItemSummary, dispatch, formatMessage, refetchNotification],
  )

  const updateDisplayHistory = useCallback(
    ({ notificationId, displayHistory }) => {
      onUpdateDisplayHistory(displayHistory, notificationId)
      effects.apis
        .updateDisplayHistory({ notificationId, displayHistory })
        .catch((error) => {
          onUpdateDisplayHistory(!displayHistory, notificationId)
          return dispatch(
            MessageAlert.showNetworkError(formatMessage)(
              error,
              errorTypes.default,
            ),
          )
        })
    },
    [dispatch, formatMessage, onUpdateDisplayHistory],
  )

  function disableButton() {
    setIsFormValid(false)
  }

  function enableButton() {
    setIsFormValid(true)
  }

  const [selectedMenu, setSelectedMenu] = useState(null)
  const infoErrorMessage = useMemo(
    () =>
      R.unless(
        R.isNil,
        R.compose(
          (msg) => <ErrorView title={msg} />,
          R.prop('message'),
          networkErrorToMessage(formatMessage),
        ),
      )(infoError),
    [formatMessage, infoError],
  )

  const handleClickSelectMenu = (event) => {
    setSelectedMenu(event.currentTarget)
  }

  const handleCloseSelectMenu = () => {
    setSelectedMenu(null)
  }
  const handleEditMenu = () => {
    setSelectedMenu(null)
  }

  const handleDownloadEventSummaryMenu = (fileType) => {
    const mimeType = fileType === 'pdf' ? 'application/pdf' : 'text/csv'
    setSelectedMenu(null)
    effects.apis
      .downloadEventNotification({
        notificationId: props.notification.id,
        action: fileType,
      })
      .then((response) => {
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(
          new Blob([response], { type: mimeType }),
        )

        link.setAttribute(
          'download',
          `${R.prop('title', notification)}_summary.${fileType}`,
        ) //any other extension
        document.body.appendChild(link)

        link.click()
        link.remove()
      })
  }

  const handleEditInitialNotification = () => {
    onEditInitialNotification()
  }

  const menuButton = () => {
    const notificationTypeCode = notification.type

    if (notificationTypeCode === API_EVENT_NOTIFICATION) {
      if (messageExpiration.hasExpired) return null

      // switch (notification.eventStatus) {
      //   case notificationEventStatus.upcoming.status:
      //   case notificationEventStatus.happening.status:
      //   case notificationEventStatus.normal.status:
      //     return (
      //       <EventNotificationActions
      //         handleClickSelectMenu={handleClickSelectMenu}
      //         handleEditMenu={handleEditMenu}
      //         onCloseSelectMenu={handleCloseSelectMenu}
      //         selectedMenu={selectedMenu}
      //         notification={notification}
      //         handleDownloadEventSummary={handleDownloadEventSummaryMenu}
      //       />
      //     );
      //   default:
      //     return null;
      // }
      return (
        <EventNotificationActions
          handleClickSelectMenu={handleClickSelectMenu}
          handleEditMenu={handleEditMenu}
          onCloseSelectMenu={handleCloseSelectMenu}
          selectedMenu={selectedMenu}
          notification={notification}
          handleDownloadEventSummary={handleDownloadEventSummaryMenu}
        />
      )
    } else if (
      [API_GENERAL_NOTIFICATION, API_VOUCHER_NOTIFICATION].includes(
        notificationTypeCode,
      )
    ) {
      switch (notificationType) {
        case NORMAL_NOTIFICATION: {
          return (
            <div className={clsx(isDownXs ? '' : 'p-8')}>
              <UnsendNotificationButton
                handleEditMenu={handleEditMenu}
                notification={notification}
              />
            </div>
          )
        }
        case SCHEDULED_NOTIFICATION: {
          if (isExist('scheduleCancelDate')(notification))
            return (
              <CancelScheduleNotificationStatus
                selectedMenu={selectedMenu}
                notification={notification}
              />
            )
          else if (
            isSentScheduledNotification(notification) &&
            !R.equals(notificationTypeCode, TYPE_VOUCHER)
          ) {
            return <UnsendNotificationButton notification={notification} />
          } else if (
            R.equals(notificationTypeCode, TYPE_VOUCHER) &&
            moment(notification.endTime).isBefore(moment())
          ) {
            return null
          } else {
            return (
              <div>
                <Button
                  className={clsx('min-w-4', isDownXs ? 'p-0 m-0' : '')}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClickSelectMenu}
                >
                  <Icon>more_vert</Icon>
                </Button>
                <Menu
                  id="simple-menu"
                  className="mt-36"
                  anchorEl={selectedMenu}
                  keepMounted
                  open={Boolean(selectedMenu)}
                  onClose={handleCloseSelectMenu}
                >
                  <MenuItem className="min-h-12" onClick={handleEditMenu}>
                    <Typography variant="caption">
                      <FormattedMessage id="edit.label" />
                    </Typography>
                  </MenuItem>
                  <MenuItem className="min-h-12">
                    <CancelScheduleNotification
                      onClick={handleCloseSelectMenu}
                      notification={notification}
                    >
                      <Typography variant="caption">
                        <FormattedMessage id="notificationTimeline.card.menu.cancel" />
                      </Typography>
                    </CancelScheduleNotification>
                  </MenuItem>
                </Menu>
              </div>
            )
          }
        }
        case INITIAL_NOTIFICATION: {
          return (
            <div>
              <IconButton
                color="secondary"
                onClick={handleEditInitialNotification}
                className="p-0 sm:p-16"
              >
                <Icon>create</Icon>
              </IconButton>
            </div>
          )
        }

        default:
          return null
      }
    }
  }

  const renderMediaSection = (notification) => {
    const media = R.prop('media', notification)
    if (R.isNil(media)) {
      return null
    }
    switch (media.type) {
      case 'video_link':
        return (
          <FrameShowYoutube
            url={media.url}
            width="100%"
            height="350px"
          ></FrameShowYoutube>
        )
      case 'image':
        return (
          <TimelineImageSection
            media={R.prop('images', notification)}
            classes={classes}
            onClickImage={() => {
              setLightboxState({
                isOpen: true,
                images: mediaToImages(R.propOr(null, 'images', notification)),
              })
            }}
          />
        )
      case 'pdf':
        return (
          <PDFMediaSection
            fileSize={media.fileSizeInMegabytes}
            fileName={media.fileName}
            onClick={() => window.open(media.url, '_blank')}
          ></PDFMediaSection>
        )
      default:
        return null
    }
  }

  const getRecipientForTitle = (index, recipientList) => {
    return (
      <Typography
        className={clsx(
          classes.darkGreyText,
          'font-semibold inline-flex ltr:pr-4 rtl:pl-4',
        )}
      >
        {R.compose(
          getLimitLengthName,
          R.prop('name'),
          formatHomelessSubgroup(formatMessage),
          R.path([index]),
        )(recipientList)}
      </Typography>
    )
  }

  const getAndForTitle = () => {
    return (
      <Typography
        className={clsx(
          classes.darkGreyText,
          'ltr:pr-4 rtl:pl-4 inline-flex flex-shrink-0',
        )}
      >
        <FormattedMessage id="notificationTimeline.card.subgroupList.and" />
      </Typography>
    )
  }

  const getOthersSubgroupForTitle = (subgroups) => {
    return (
      <Typography
        className={clsx(
          classes.darkGreyText,
          'flex-shrink-0 ltr:pr-4 rtl:pl-4',
        )}
      >
        <FormattedMessage
          id="notificationTimeline.card.subgroupList.otherGroups"
          values={{
            subgroupCount: R.o(R.subtract(R.__, 1), R.length, subgroups),
          }}
        />
      </Typography>
    )
  }

  const getSocialChannels = (notification) =>
    R.filter(
      (channel) =>
        R.includes(channel, [
          TWITTER_VALUE,
          FACEBOOK_VALUE,
          INSTAGRAM_VALUE,
          LINKEDIN_VALUE,
        ]),
      R.prop('channels', notification),
    )

  const getSocialMedia = (notification, isAlsoPosted) => {
    const socialChannels = getSocialChannels(notification)

    if (R.isEmpty(socialChannels) || R.isNil(socialChannels)) {
      return false
    }

    const renderSocialChannels = (item) => {
      switch (item) {
        case TWITTER_VALUE:
          return (
            <img
              className={`${!isAlsoPosted ? 'mt-1' : ''}`}
              key={item}
              alt="twitter-logo"
              width="14"
              height="14"
              src={Assets.twitterIcon}
            />
          )
        case FACEBOOK_VALUE:
          return (
            <img
              className={`${!isAlsoPosted ? 'mt-1' : ''}`}
              key={item}
              alt="facebook-logo"
              width="14"
              height="14"
              src={Assets.facebookIcon}
            />
          )
        case INSTAGRAM_VALUE:
          return (
            <img
              className={`${!isAlsoPosted ? 'mt-1' : ''}`}
              key={item}
              alt="instagram-logo"
              width="14"
              height="14"
              src={Assets.instagramIcon}
            />
          )
        case LINKEDIN_VALUE:
          return (
            <img
              className={`${!isAlsoPosted ? 'mt-1' : ''}`}
              key={item}
              alt="linkedin-logo"
              width="14"
              height="14"
              src={Assets.linkedinIcon}
            />
          )
        default:
          return ''
      }
    }

    return (
      <div className={clsx('flex space-x-4')}>
        {socialChannels.map((item) => renderSocialChannels(item))}
      </div>
    )
  }

  const alsoPostedOnSocials = (notification) => {
    if (!getSocialMedia(notification)) {
      return false
    }

    return (
      <div className="flex also-posted-on-socials-wrapper">
        <Typography className="font-normal also-posted-on-socials-title">
          <FormattedMessage id="notificationTimeline.card.alsoNotificationPostedOnSocialMedia" />
          :
        </Typography>
        <div className="flex justify-center pl-5">
          {getSocialMedia(notification, true)}
        </div>
      </div>
    )
  }

  const getRecipientList = (subgroups, subscribers) => {
    if (R.isEmpty(subgroups) && R.isEmpty(subscribers)) {
      return false
    }

    const recipientList = [
      ...R.map((group) => {
        return { name: group.name }
      }, subgroups),
      ...R.map((sub) => {
        return { name: `${sub.firstName} ${sub.lastName}` }
      }, subscribers),
    ]
    const firstElement = 0
    const secondElement = 1

    if (R.o(R.equals(1), R.length, recipientList)) {
      return getRecipientForTitle(firstElement, recipientList)
    }

    if (R.o(R.equals(2), R.length, recipientList)) {
      return (
        <>
          {getRecipientForTitle(firstElement, recipientList)}
          <div className="flex">
            {getAndForTitle()}
            {getRecipientForTitle(secondElement, recipientList)}
          </div>
        </>
      )
    }

    if (R.o(R.gt(R.__, 2), R.length, recipientList)) {
      return (
        <>
          {getRecipientForTitle(firstElement, recipientList)}
          <div className="flex">
            {getAndForTitle()}
            {getOthersSubgroupForTitle(recipientList)}
          </div>
        </>
      )
    }

    return (
      <Typography className={clsx(classes.darkGreyText, 'font-semibold')}>
        <FormattedMessage id="notificationTimeline.card.subgroupList.allSubscribers" />
      </Typography>
    )
  }

  const getRecipientTooltipTitle = (subGroups, subscribers) => {
    if (
      (subGroups && !R.isEmpty(subGroups)) ||
      (subscribers && !R.isEmpty(subscribers))
    ) {
      return recipientToTooltipDisplay(formatMessage)(subGroups, subscribers)
    } else {
      if (
        subGroups &&
        R.isEmpty(subGroups) &&
        subscribers &&
        R.isEmpty(subscribers)
      ) {
        return ''
      }
      return formatMessage({
        id: 'notificationTimeline.card.subgroupList.allSubscribers',
      })
    }
  }

  const getSubgroupsPrefix = (notification, notificationType) => {
    const channels = getChannels(notification)

    const isSchedule = R.and(
      notificationType === SCHEDULED_NOTIFICATION,
      !isSentScheduledNotification(notification),
    )
    const isSocialMedia = R.and(
      R.isEmpty(R.prop('subGroups')(notification)),
      R.isEmpty(channels),
    )
    const socialMediaMsg = formatMessage({
      id: 'notificationTimeline.card.subgroupList.socialMediaNotifications.prefix',
    })

    if (isSchedule) {
      if (isSocialMedia) {
        return socialMediaMsg
      }

      return formatMessage({
        id: 'notificationTimeline.card.subgroupList.scheduledNotification.prefix',
      })
    }
    if (isSocialMedia) {
      return socialMediaMsg
    }

    return formatMessage({
      id: 'notificationTimeline.card.subgroupList.normalNotification.prefix',
    })
  }

  const hasReminderDate = R.compose(
    R.not,
    R.anyPass([R.isNil, R.isEmpty]),
    R.prop('reminderDate'),
  )

  const getLastModifiedTime = (notification) => {
    const lastModifiedDateTime = R.prop('updatedAt', notification)
    const date = getLocalizedDate(lastModifiedDateTime, 'DATE')
    const time = getLocalizedDate(lastModifiedDateTime, 'TIME')
    return formatMessage(
      { id: 'notificationTimeline.card.lastModifiedTime' },
      { time, date },
    )
  }

  const getNotificationTime = (notification) => {
    const sentDate = R.prop('sendDate', notification)
    const scheduledDateTime = R.prop('scheduleDate', notification)
    const scheduledTimezone = R.prop('scheduleTimezone', notification)
    const offsets = momentTimezone
      .tz(scheduledDateTime, scheduledTimezone)
      .format('Z')

    const isScheduleCancelDate = isExist('scheduleCancelDate')(notification)
    const isSchedule = notificationType === SCHEDULED_NOTIFICATION
    const isSentSchedule = isSentScheduledNotification(notification)

    const formatDateTime = (formatId, dateTime, timezone, offsets) =>
      formatMessage(
        {
          id: formatId,
        },
        {
          ...parseDateAndTimeAndTimezone(dateTime, timezone),
          offsets: offsets,
        },
      )

    const humanizedScheduledTime = humanizedTimeIndicator({
      timestamp: sentDate,
      languageCode: R.prop('code', defaultLanguage),
      formatMessage: formatMessage,
      timezone: scheduledTimezone,
    })

    if (isScheduleCancelDate) {
      const cancelScheduledDateTime = R.prop('sendDate', notification) // replace scheduleCancelDate
      const cancelScheduledTimezone = R.prop('timezone', notification)
      const cancelScheduledOffsets = momentTimezone
        .tz(cancelScheduledDateTime, cancelScheduledTimezone)
        .format('Z')
      const cancelDate = formatDateTime(
        'notificationTimeline.card.scheduledTime.cancelled',
        cancelScheduledDateTime,
        cancelScheduledTimezone,
        cancelScheduledOffsets,
      )
      return <span>{cancelDate}</span>
    }

    if (isSchedule) {
      if (!isSentSchedule) {
        const scheduledDate = formatDateTime(
          'notificationTimeline.card.scheduledTime',
          scheduledDateTime,
          scheduledTimezone,
          offsets,
        )
        return <span>{scheduledDate}</span>
      }
      return <span>{humanizedScheduledTime}</span>
    }
    return <span>{notification.humanizedTimeIndicator}</span>
  }

  const LIMIT_NAME_LENGTH = 20

  const getLimitLengthName = R.when(
    R.propSatisfies(R.gt(R.__, LIMIT_NAME_LENGTH), 'length'),
    R.pipe(R.take(LIMIT_NAME_LENGTH), R.append('…'), R.join('')),
  )

  const getChannels = (notification) =>
    R.filter(
      (item) =>
        R.includes(item, [
          CHANNEL_APP,
          CHANNEL_CALL,
          CHANNEL_EMAIL,
          CHANNEL_SMS,
        ]),
      R.prop('channels')(notification),
    )

  const getCardTitle = (notification, notificationType) => {
    switch (notificationType) {
      case INITIAL_NOTIFICATION: {
        const placeName = R.path(['place', 'name'], notification)
        return (
          <div className="flex cursor-default flex-wrap">
            <Typography
              className={clsx(
                classes.darkGreyText,
                'font-medium ltr:mr-4 rtl:ml-4 font-semibold',
              )}
              paragraph={false}
            >
              {placeName}
            </Typography>
          </div>
        )
      }
      default: {
        const channels = getChannels(notification)
        return (
          <div
            className={clsx(
              'flex cursor-default flex-wrap',
              isDownXs ? 'flex-col' : '',
            )}
          >
            <Typography
              className={clsx(
                classes.darkGreyText,
                'flex font-medium ltr:mr-4 rtl:ml-4 font-semibold truncate ...',
              )}
              paragraph={false}
            >
              {R.o(getLimitLengthName, R.prop('posterName'), notification)}
            </Typography>
            <div className={clsx('flex', classes.messageSentByCont)}>
              <Typography
                className={clsx(
                  classes.darkGreyText,
                  'ltr:pr-4 rtl:pl-4 inline-flex flex-shrink-0',
                )}
              >
                {isTranslation
                  ? getSubgroupsPrefix(notification, notificationType)
                  : preparingMsg}
                {/* {getSubgroupsPrefix(notification, notificationType)} */}
              </Typography>
              <Tooltip
                title={getRecipientTooltipTitle(
                  R.prop('subGroups', notification),
                  R.prop('subscribers', notification),
                )}
              >
                <div className={clsx('inline-flex', classes.messageSentBy)}>
                  {getRecipientList(
                    R.prop('subGroups', notification),
                    R.prop('subscribers', notification),
                  ) || getSocialMedia(notification)}
                </div>
              </Tooltip>

              <ViaChannelCount
                channels={channels}
                notificationId={notificationId}
              />
            </div>
          </div>
        )
      }
    }
  }

  const getCardAvatar = useCallback(
    (notification, notificationType) => {
      const src = R.o(
        R.defaultTo(Assets.defaultPlaceImage),
        R.path(['place', 'image']),
        notification,
      )

      const isNotUser = R.isNil(notification.user)

      switch (notificationType) {
        case INITIAL_NOTIFICATION: {
          return <Avatar aria-label="Recipe" src={src} />
        }
        default: {
          return R.path(['user', 'avatar'], notification) ? (
            <PersonAvatar
              placeHolder={R.o(
                R.defaultTo(Assets.defaultPlaceImage),
                R.path(['user', 'avatarCharacters']),
                notification,
              )}
              subId={isNotUser ? null : notification.user.id}
              alt={isNotUser ? 'UserExpired' : notification.user.firstName}
              src={R.o(
                R.defaultTo(Assets.defaultPlaceImage),
                R.path(['user', 'avatar']),
                notification,
              )}
            />
          ) : (
            <Avatar
              {...createAvatarFromCharacters(
                R.path(['user', 'avatarCharacters'], notification),
              )}
            ></Avatar>
          )
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [notification.id],
  )

  const getNotificationTypeBadge = (type) => {
    switch (type) {
      case API_EVENT_NOTIFICATION:
        return (
          <NotificationBadge
            localizedId={formatMessage({ id: 'notiType.event.label' })}
            imageAsset={Assets.notiTypeInNotiCard.event}
          />
        )

      default:
        return (
          <NotificationBadge
            localizedId={formatMessage({ id: 'notiType.general.label' })}
            imageAsset={Assets.notiTypeInNotiCard.info}
          />
        )
    }
  }

  const subtitleSeparator = <span className="mx-1">·</span>

  const getCardSubtitle = (notification, notificationType) => {
    switch (notificationType) {
      case INITIAL_NOTIFICATION: {
        return (
          <Typography className={clsx(classes.darkGreyText, 'text-xs')}>
            {getLastModifiedTime(notification)}
          </Typography>
        )
      }
      default: {
        return (
          <>
            <DisplayHistoryToggle
              notification={notification}
              updateDisplayHistory={updateDisplayHistory}
            />
            <Typography
              className={clsx(classes.lightGreyText, 'text-xs cursor-default')}
            >
              {getNotificationTime(notification)}
              {subtitleSeparator}
              {getNotificationTypeBadge(
                R.propOr(API_GENERAL_NOTIFICATION, 'type', notification),
              )}
              {subtitleSeparator}
              {notificationPriority(notification)}
              <ReminderBadge notification={notification} />
            </Typography>
          </>
        )
      }
    }
  }

  const getEventDate = (
    startDateTime,
    endDateTime,
    stratTimezone,
    endTimezone,
  ) => {
    const startDate = changeTimezone(startDateTime, stratTimezone).format(
      eventDateFormat,
    )
    const startTime = changeTimezone(startDateTime, stratTimezone).format(
      timeFormat,
    )
    const startOffsets = momentTimezone.tz(stratTimezone).format('Z')
    const eventDateComponent = (eventDate) => (
      <div className={clsx('pb-8')}>
        <Typography
          component="span"
          className={clsx(classes.eventDate, 'break-word text-xs')}
        >
          {eventDate}
        </Typography>
      </div>
    )

    if (R.anyPass([R.isNil, R.isEmpty])(endDateTime)) {
      return eventDateComponent(
        <FormattedMessage
          id="label.date.utc"
          values={{ date: startDate, time: startTime, offsets: startOffsets }}
        />,
      )
    } else {
      const endDate = momentTimezone(endDateTime)
        .tz(endTimezone)
        .format(eventDateFormat)
      const endTime = momentTimezone(endDateTime)
        .tz(endTimezone)
        .format(timeFormat)
      const endOffsets = momentTimezone.tz(endTimezone).format('Z')

      return eventDateComponent(
        <FormattedMessage
          id="label.start.to.until.date.utc"
          values={{
            startDate,
            startTime,
            startOffsets,
            endDate,
            endTime,
            endOffsets,
          }}
        />,
      )
    }
  }

  const getEventLocation = (eventLocation) => {
    return (
      <Typography
        className={clsx(
          classes.eventLocation,
          'pb-8 break-all uppercase text-xs',
        )}
      >
        <img
          src={Assets.event.eventLocation}
          className="ltr:mr-4 rtl:ml-4"
          alt="event location icon"
        />
        {eventLocation}
      </Typography>
    )
  }

  const openEventActionSubscribersDialog = (
    notificationId,
    action,
    subscriberCount,
  ) => {
    if (subscriberCount > 0) {
      setEventActionDialog({ notificationId, action, subscriberCount })
      openEventSubscribersDialog()
    }
  }

  const theme = useTheme()
  const isDownXs = useMediaQuery(theme.breakpoints.down('xs'))
  const commentLabelPlaceHolder = formatMessage(
    {
      id: 'notificationTimeline.card.comment.label',
    },
    { creatorName },
  )

  let audioPlayer = '' // audio

  useEffect(() => {
    if (isPageLoad) {
      checkAudio(notificationId, selectedLanguageId).then(({ audioUrl }) => {
        if (audioUrl) {
          setAudioUrlCheck(audioUrl)
        }
      })
    }
    setIsPageLoad(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLanguageId])

  //data for metrics new version
  const [metricsDetail, setMetricsDetail] = useState()
  const [allowConversation, setAllowConversation] = useState(
    notification.allowConversation,
  )
  const cancelToken = Axios.CancelToken.source()
  const [catchedError, setCatchedError] = useState()
  const [isLoadingMetrics, setIsLoadingMetrics] = useState(false)
  const imageRegex = /<img([\w\W]+?)>/g
  var imageInBody = notification.body
    ? notification.body.match(imageRegex) || []
    : []
  const isShowCollapse =
    imageInBody.length > 1 ? true : notification.descriptionPreview.length > 200

  const [isShowPreviewDescription, setIsShowPreviewDescription] =
    useState(false)

  const [isScrollPreview, setIsScrollPreview] = useState(false)
  const [metricsType, setMetricsType] = useState(DEFAULT_METRIC)
  const mes_4386_dashbooard_chats_coming_soon = useFlag(
    'mes_4386_dashbooard_chats_coming_soon',
  )
  const hide_toggle_chat = useFlag('hide-toggle-chat')

  const getCurrentMetricsData = (metricsType) => {
    if (metricsType === 'socialMediaInteractions') {
      setIsLoadingMetrics(true)
      effects.apis
        .getNotificationSocialMediaInteractions({
          placeId: place.id,
          notificationId,
          cancelToken,
        })
        .then((res) => {
          setIsLoadingMetrics(false)
          setMetricsDetail(res)
        })
        .catch((err) => {
          setIsLoadingMetrics(false)
          setMetricsDetail({})
          setCatchedError({ error: err.response.data.details.message })
        })
    } else {
      setIsLoadingMetrics(true)
      effects.apis
        .getNotificationTimelineMetrics({
          timeLineId: notificationId,
          metricsType,
        })
        .then((res) => {
          setIsLoadingMetrics(false)
          setMetricsDetail(res)
        })
        .catch((err) => {
          setIsLoadingMetrics(false)
          setMetricsDetail({ listened: [], fullListened: [] })
          setCatchedError({ error: err.response.data.details.message })
        })
    }
  }

  async function handleCheckAudioUrl(notificationId, langId) {
    setAudioUrlCheck(AUDIO_PROCESS)
    let { audioUrl } = await checkAudio(notificationId, langId)

    setAudioUrlCheck(audioUrl || undefined)
  }

  let handleAllowConversationToggleChange = (e) => {
    setAllowConversation(e.target.checked)
    notification.allowConversation = e.target.checked
    notification.priority = 1
    notification.entityType = 1
    effects.apis.updateInitialNotification({ data: notification })
  }

  let isHidePlayer = isEnabledTts === 0 && isHideTtsHistory === 1

  if (
    !isHidePlayer &&
    notification.isTtsEnabled &&
    notification.scope !== INITIAL_SCOPE
  ) {
    if (!availableLangs.includes(notification.language.code)) {
      audioPlayer = (
        <div className={classes.audioPlayerWrapper}>
          <div className={classes.ttsProcessingTxt}>
            {formatMessage(
              { id: 'audioPlayer.notSupported.text' },
              { languageName: notification.language.name },
            )}
          </div>
        </div>
      )
    } else if (!notification.audioUrl) {
      if (Number(notification.isTtsEnabledTarget)) {
        audioPlayer = (
          <div className={classes.audioPlayerWrapper}>
            {audioUrlCheck === undefined ? (
              <div className="inline-block text-grey-66 mr-16">
                {formatMessage({ id: 'audioPlayer.stillProcessing.text' })}
              </div>
            ) : audioUrlCheck === AUDIO_PROCESS ? (
              <div className={classes.ttsProcessingTxt}>
                {formatMessage({
                  id: 'audioPlayer.stillProcessing.checking',
                })}
              </div>
            ) : (
              <div className={classes.ttsProcessingTxt}>
                {formatMessage({
                  id: 'audioPlayer.stillProcessing.notReady',
                })}
              </div>
            )}
            {audioUrlCheck === undefined && (
              <button
                className="text-blue-primary"
                onClick={() =>
                  handleCheckAudioUrl(notification.id, notification.language.id)
                }
              >
                {formatMessage({
                  id: 'audioPlayer.stillProcessing.checkNow.btn',
                })}
              </button>
            )}
          </div>
        )
      }
    } else {
      audioPlayer = (
        <NotificationCardAudio
          isOnline={isOnline}
          currentMusicPlaying={currentMusicPlaying}
          notification={notification}
        />
      )
    }
  }

  const renderProcessingTranslation = () => {
    return (
      <div className="px-16 pt-0 pb-4">
        <Box className="bg-grey-95 rounded-lg mb-10 py-5">
          <div className="flex justify-center py-2">
            <Status
              status={'disabled'}
              icon={'autorenew_icon'}
              statusText={formatMessage({
                id: 'notificationTimeline.card.translation.processing.status',
              })}
              className={'text-16 font-semibold text-grey-66 ml-3'}
            />
          </div>
          <div className="flex justify-center py-2">
            <div className="text-12 font-semibold text-grey-66">
              {formatMessage({
                id: 'notificationTimeline.card.translation.processing.description',
              })}
            </div>
          </div>
        </Box>
      </div>
    )
  }
  const showMoreBtn = () => {
    setIsScrollPreview(true)
    isShowPreviewDescription
      ? setIsShowPreviewDescription(false)
      : setIsShowPreviewDescription(true)
  }

  useEffect(() => {
    isScrollPreview &&
      setTimeout(() => {
        if (
          R.compose(
            R.not,
            R.anyPass([R.isNil, R.isEmpty]),
            R.prop('current'),
          )(scrollRef)
        )
          scrollRef.current.scrollIntoView({ behavior: 'smooth' })
      }, 0)
  }, [isScrollPreview, isShowPreviewDescription])

  useEffect(() => {
    if (audioUrlCheck && audioUrlCheck !== AUDIO_PROCESS) {
      notification.audioUrl = audioUrlCheck
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audioUrlCheck])

  return (
    <ErrorBoundary
      fallback={
        <div className="flex flex-col p-8 rounded shadow-lg">
          <span className="font-bold">
            <FormattedMessage id="error.general" />
          </span>
        </div>
      }
    >
      <Card
        key={notification.id}
        className="w-full p-8"
        {...extraProps}
        ref={scrollRef}
      >
        <CardHeader
          avatar={getCardAvatar(notification, notificationType)}
          action={
            <>
              {isDownXs || !isTranslation ? undefined : isInterval &&
                !R.isNil(translationFaileId) ? (
                <Status
                  status={'approve'}
                  icon={'done_icon'}
                  statusText={
                    <FormattedMessage id="notificationTimeline.card.translation.completed" />
                  }
                  className={'text-xs font-semibold ml-2'}
                />
              ) : (
                menuButton()
              )}
              {R.not(
                R.and(
                  R.isEmpty(R.prop('subGroups')(notification)),
                  R.isEmpty(R.prop('subscribers')(notification)),
                  R.isEmpty(getChannels(notification)),
                ),
              ) && alsoPostedOnSocials(notification)}
            </>
          }
          title={
            isDownXs ? (
              <div className="flex flex-row justify-between items-start">
                {getCardTitle(notification, notificationType)} {menuButton()}
              </div>
            ) : (
              <div>{getCardTitle(notification, notificationType)}</div>
            )
          }
          subheader={getCardSubtitle(notification, notificationType)}
          className={clsx(
            'flex items-start ltr:pr-18 rtl:pl-18',
            classes.cardHeaderPadding,
          )}
        ></CardHeader>
        <Divider variant="middle" />
        {messageExpiration.hasExpiration && (
          <>
            <CancelExpirationButton messageExpiration={messageExpiration} />
            <Divider variant="middle" />
          </>
        )}

        <CardContent className="p-0">
          <div className="p-16 pb-0 mb-10">
            {R.propEq('type', API_EVENT_NOTIFICATION)(notification) &&
              R.prop('startTime', notification) &&
              getEventDate(
                R.prop('startTime', notification),
                R.prop('endTime', notification),
                R.prop('startTimezone', notification) ||
                  R.prop('timezone', notification),
                R.prop('endTimezone', notification) ||
                  R.prop('timezone', notification),
              )}
            <div dir="auto">
              <div className="py-0 font-semibold break-word">
                <RichTextDisplay text={R.prop('title', notification)} />
                {isShowStatus && (
                  <Chip
                    className={clsx(classes.chipStatusStyle, classColorStatus)}
                    label={formatMessage({
                      id: eventStatusLabelId,
                    })}
                  />
                )}
              </div>
            </div>
            {R.propEq('type', API_EVENT_NOTIFICATION) &&
              R.prop('address', notification) && (
                <div dir="auto">
                  {getEventLocation(R.prop('address', notification))}
                </div>
              )}
            {mes_718_show_more_description && !isInitialNotification ? (
              <>
                {isShowPreviewDescription || !isShowCollapse ? (
                  <>
                    <div dir="auto" className="flex">
                      <div className="pb-8 mt-8 break-word w-full">
                        <RichTextDisplay text={R.prop('body', notification)} />
                      </div>
                    </div>
                    {isTranslation && (
                      <div>
                        {R.propEq(
                          'type',
                          API_EVENT_NOTIFICATION,
                        )(notification) && (
                          <NotificationCardEventActions
                            notification={notification}
                            openEventActionSubscribersDialog={
                              openEventActionSubscribersDialog
                            }
                          />
                        )}
                        {R.prop('voucher', notification) && (
                          <AttachedVoucherSection
                            voucher={R.prop('voucher', notification)}
                            selectedLanguageId={selectedLanguageId}
                            toggleVoucher={toggleVoucher}
                          />
                        )}
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <div dir="auto" className="flex">
                      <div className="pb-8 mt-8 break-word w-full relative">
                        <RichTextDisplay
                          text={R.prop('descriptionPreview', notification)}
                        />
                        <div className={classes.textPreview}></div>
                      </div>
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                <div dir="auto" className="flex">
                  <div className="pb-8 mt-8 break-word w-full">
                    <RichTextDisplay text={R.prop('body', notification)} />
                  </div>
                </div>
                {isTranslation && (
                  <div>
                    {R.propEq('type', API_EVENT_NOTIFICATION)(notification) && (
                      <NotificationCardEventActions
                        notification={notification}
                        openEventActionSubscribersDialog={
                          openEventActionSubscribersDialog
                        }
                      />
                    )}
                    {R.prop('voucher', notification) && (
                      <AttachedVoucherSection
                        voucher={R.prop('voucher', notification)}
                        selectedLanguageId={selectedLanguageId}
                        toggleVoucher={toggleVoucher}
                      />
                    )}
                  </div>
                )}
              </>
            )}

            {mes_718_show_more_description &&
              !isInitialNotification &&
              isShowCollapse && (
                <Button
                  onClick={showMoreBtn}
                  className={clsx(classes.previewButton, 'normal-case')}
                >
                  {!isShowPreviewDescription ? (
                    <div className="text-blue-primary flex">
                      {formatMessage({ id: 'crm.form.showMoreBtn' })}{' '}
                      <ExpandMoreIcon />
                    </div>
                  ) : (
                    <div className="text-blue-primary flex">
                      {formatMessage({ id: 'crm.form.showLessBtn' })}{' '}
                      <ExpandLessIcon />
                    </div>
                  )}
                </Button>
              )}

            {/* Show comming soonby condition */}
            {isInitialNotification && mes_4386_dashbooard_chats_coming_soon ? (
              <div className="text-14 text-blue-950 p-14 my-5 bg-primary-200 rounded-8 flex flex-col gap-12">
                <div>
                  <FormattedMessage id="conversations.new.comingSoon.title" />
                </div>
                <div>
                  <FormattedMessage id="conversations.new.comingSoon.subtitle" />
                </div>
              </div>
            ) : null}
            {/* Hide Toggle for Chat */}
            {hide_toggle_chat ? null : (
              <FormControlLabel
                className="flex flex-row-reverse ltr:ml-0 rtl:mr-0 allow-conversation-toggle"
                control={
                  <div className="ltr:ml-8 rtl:mr-8 ltr:mr-12 rtl:ml-12 container-block">
                    <DefaultSwitch
                      checked={allowConversation}
                      onChange={(e) => {
                        handleAllowConversationToggleChange(e)
                      }}
                      disabled={false}
                    />
                  </div>
                }
                labelPlacement="start"
                label={
                  <Typography color="textSecondary" variant="body2">
                    <FormattedMessage id="initialNotification.allowConversation.label" />
                  </Typography>
                }
              />
            )}
          </div>
          {isTranslation ? (
            <>
              {hasReminderDate(notification) && (
                <div className="w-full px-16">
                  <CancelReminderButton notification={notification} />
                </div>
              )}
              {!isInitialNotification && (
                <PaidPlanAccess
                  freePlanComponent={
                    <div className="m-16">
                      <GreyBox border>
                        <PaidPlanAccessBlock titleId="paidPlanRestriction.commentTranslationMetric.description.text" />
                      </GreyBox>
                    </div>
                  }
                >
                  {!R.propEq('type', API_EVENT_NOTIFICATION) ||
                    (R.propEq('type', API_EVENT_NOTIFICATION) &&
                      hasReminderDate(notification) && (
                        <Divider variant="middle" />
                      ))}

                  <div className="px-16 pt-0 pb-4">
                    {audioPlayer}
                    {/* Add List Topics */}
                    {!R.isEmpty(placeTopics) && (
                      <Grid container className="w-full mb-12">
                        {placeTopics
                          .filter((topic, index) => {
                            return R.prop('isSelected', topic)
                          })
                          .map((topic, index) => {
                            return (
                              <div className="mr-2" key={index}>
                                <Topic id={topic.place_id} name={topic.name} />
                              </div>
                            )
                          })}
                      </Grid>
                    )}
                    <div className="flex flex-col-reverse sm:flex-row sm:justify-between">
                      <div
                        className={clsx(
                          'flex whitespace-nowrap',
                          'justify-start',
                          'cursor-pointer',
                          'items-center',
                          'mb-8 sm:mb-0',
                        )}
                        onClick={onToggleShowComments}
                      >
                        <Typography
                          className={clsx(
                            classes.darkGreyText,
                            'flex text-xs mb-6',
                            'font-bold',
                          )}
                        >
                          {commentCountText()}
                        </Typography>
                        <Typography
                          className={clsx(
                            classes.selectIcon,
                            'flex text-xs ltr:pr-8 rtl:pl-8 mb-4 cursor-pointer',
                          )}
                        >
                          {!isShowComments ? (
                            <KeyboardArrowDownIcon
                              className={clsx(classes.keyIconStyle)}
                            />
                          ) : (
                            <KeyboardArrowUpIcon
                              className={clsx(classes.keyIconStyle)}
                            />
                          )}
                        </Typography>
                      </div>
                      <div className={clsx('-mt-12', classes.shareResponsive)}>
                        {R.propEq('isSharingEnabled', true, notification) &&
                          R.propSatisfies(
                            R.isNil,
                            'unsentDate',
                            notification,
                          ) && (
                            <div
                              className={clsx(
                                'flex items-center',
                                classes.shareResponsive,
                              )}
                            >
                              <ShareButton
                                scheduleDate={R.prop(
                                  'scheduleDate',
                                  notification,
                                )}
                                scheduleDateAndTimeZone={parseDateAndTimeAndTimezone(
                                  R.prop('scheduleDate', notification),
                                  R.prop('scheduleTimezone', notification),
                                )}
                                notificationId={notificationId}
                                onCopySucceed={() => {
                                  dispatch(
                                    MessageAlert.showSuccess({
                                      message: formatMessage({
                                        id: 'notificationTimeline.card.publicLink.shareAlert.copySucceed',
                                      }),
                                    }),
                                  )
                                }}
                                onCopyFailure={(error) => {
                                  dispatch(
                                    MessageAlert.showSuccess({
                                      message: formatMessage({
                                        id: 'notificationTimeline.card.publicLink.shareAlert.copyFailure',
                                      }),
                                    }),
                                  )
                                }}
                              />
                            </div>
                          )}

                        <div className="flex flex-row items-end">
                          <Typography
                            className={clsx(
                              classes.darkGreyText,
                              'flex text-xs ltr:pr-4 rtl:pl-4 mb-16',
                              'font-bold',
                            )}
                          >
                            <FormattedMessage id="notificationTimeline.card.viewInLanguage" />
                          </Typography>
                          <ErrorBoundary
                            fallback={
                              <Typography
                                className={clsx(
                                  classes.darkGreyText,
                                  'flex text-xs mb-16',
                                )}
                              >
                                <FormattedMessage id="notificationTimeline.card.cannotGetLanguage" />
                              </Typography>
                            }
                          >
                            <ViewInButton
                              notificationId={notificationId}
                              languageId={(value) =>
                                setSelectedLanguageId(value)
                              }
                              defaultLanguage={selectedLanguage}
                              Language={(value) => {
                                setSelectedLanguage(value)
                                setAudioUrlCheck(value.audioUrl)
                              }}
                            />
                          </ErrorBoundary>
                        </div>
                        {!isInitialNotification &&
                          !notification.metricDisabled && (
                            <div
                              className={clsx(
                                'flex items-end',
                                'cursor-pointer',
                              )}
                              onClick={onToggleShowMetrics}
                            >
                              <Typography
                                className={clsx(
                                  classes.darkGreyText,
                                  'flex text-xs mb-16 cursor-pointer',
                                  'font-bold',
                                )}
                              >
                                <FormattedMessage id="notificationTimeline.card.action.viewMetricDetail" />
                              </Typography>

                              <Typography
                                className={clsx(
                                  classes.selectIcon,
                                  'flex text-xs mb-16 cursor-pointer',
                                )}
                              >
                                {!isShowMetrics ? (
                                  <KeyboardArrowDownIcon
                                    className={clsx(classes.keyIconStyle)}
                                  />
                                ) : (
                                  <KeyboardArrowUpIcon
                                    className={clsx(classes.keyIconStyle)}
                                  />
                                )}
                              </Typography>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </PaidPlanAccess>
              )}
            </>
          ) : (
            renderProcessingTranslation()
          )}
        </CardContent>
        {isShowComments && (
          <>
            <div className="mx-8 flex items-center justify-between">
              <Typography variant="h6" className="m-8 font-bold text-base">
                <FormattedMessage id="notificationTimeline.card.comments.title" />
              </Typography>
              {isInfoLoading ? (
                <SmallLoading />
              ) : (
                <IconLinkButton icon="refresh" onClick={refetchNotification} />
              )}
            </div>
            <CardContent className={clsx(classes.cardPadding)}>
              <div className="flex mt-8">
                <PersonAvatar
                  placeHolder={R.prop('avatarCharacters', userData)}
                  subId={userData.id}
                  alt={userData.firstName}
                  src={userData.avatar}
                  className={clsx(classes.avatarIcon, 'ltr:mr-5 rtl:ml-5')}
                />
                <Formsy
                  ref={commentRef}
                  className="w-full"
                  onValid={enableButton}
                  onInvalid={disableButton}
                  onSubmit={() => createComment(commentItemSummary)}
                  onKeyPress={handleEnterToSubmit}
                >
                  <TextFieldFormsy
                    name="comment"
                    id="outlined-textarea"
                    multiline
                    label={isDownXs ? undefined : commentLabelPlaceHolder}
                    placeholder={isDownXs ? commentLabelPlaceHolder : undefined}
                    className="w-full"
                    inputRef={commentTextFieldRef}
                    margin="normal"
                    variant="outlined"
                    validations={{
                      isNotEmpty: validateEmtpyValueFormsy,
                    }}
                    disabled={isSubmitting}
                  />
                  <div className="flex justify-end md:hidden">
                    <ButtonWithLoading
                      type="submit"
                      color="secondary"
                      variant="contained"
                      className="my-5"
                      isLoading={isSubmitting}
                      disabled={!isFormValid || isSubmitting}
                      labelId="notificationTimeline.card.comment.post.button"
                    />
                  </div>
                </Formsy>
              </div>
            </CardContent>
            <CardContent>
              <ExtraSection
                isShow={isShowComments}
                isLoading={isInfoLoading && R.isNil(comments)}
                errorComp={infoErrorMessage}
                Component={
                  <CardContent>
                    <CommentList
                      comments={comments}
                      CommentCardProps={{
                        entityId,
                        userData,
                        handleCommentCountFromReply,
                        deleteComment,
                        onUpdateCommentSuccess: refetchNotification,
                        onDeleteComment: refetchNotification,
                        onReplySuccess: refetchNotification,
                        onReplyUpdateSuccess: refetchNotification,
                      }}
                    />
                  </CardContent>
                }
              />
            </CardContent>

            <span
              className="ltr:pl-24 rtl:pr-24 pb-24 text-xs cursor-pointer block"
              onClick={scrollToCommentBox}
            >
              <FormattedMessage id="notificationTimeline.card.comment.post.writeComment" />
            </span>
          </>
        )}
        {isShowMetrics && (
          <div
            className={clsx(
              'mx-8 flex items-center',
              withoutAnyChannel ? 'justify-between pb-48 pl-8' : 'justify-end',
            )}
          >
            <NotificationMetricWithoutChannel
              isShow={isShowMetrics && withoutAnyChannel}
            />
            {isInfoLoading || isLoadingMetrics ? (
              <SmallLoading />
            ) : (
              <IconLinkButton
                icon="refresh"
                onClick={() => getCurrentMetricsData(metricsType)}
              />
            )}
          </div>
        )}
        <ExtraSection
          isShow={
            isShowMetrics &&
            (R.prop('channels', notification).includes(CHANNEL_APP) ||
              R.prop('channels', notification).includes(CHANNEL_CALL) ||
              R.prop('channels', notification).includes(CHANNEL_EMAIL) ||
              R.prop('channels', notification).includes(CHANNEL_SMS))
          }
          isLoading={isInfoLoading && R.isNil(metrics)}
          errorComp={infoErrorMessage}
          Component={
            <CardContent>
              <MetricAnalyticWithTabs
                getCurrentMetricsData={getCurrentMetricsData}
                metricsDetail={metricsDetail}
                catchedError={catchedError}
                /* 
                For deployment to dev I just removed socialMediaInteractions tab in metrics tab 'cause it is not ready yet.
                if you want get back socialMediaInteractions tab just pass this line below instead of TABTITLES
                getSocialChannels(notification).length !== 0 ? [...TABTITLES, SOCIAL_MEDIA_INTERACTIONS_TAB_TITLE] : TABTITLES 
                */
                TABTITLES={TABTITLES}
                metricsType={metricsType}
                setMetricsType={setMetricsType}
              />
            </CardContent>
          }
        />
      </Card>
    </ErrorBoundary>
  )
}

NotificationCard.propTypes = {
  onProfileInfoClick: PropTypes.func,
  onSubscriptionClick: PropTypes.func,
  onAnalyticClick: PropTypes.func,
  notificationType: PropTypes.string,
  onEditScheduleNotification: PropTypes.func,
  onEditInitialNotification: PropTypes.func,
  notification: PropTypes.shape({
    user: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
    notificationMedias: PropTypes.array,
    translations: PropTypes.array.isRequired,
  }), // notification from api object
}

export default NotificationCard
